const baseAccordionRootStyles = {
  borderRadius: '8px',
  border: '1px solid',
  borderColor: 'divider',
  boxShadow: 'none',
  overflow: 'hidden',
  '&::before': {
    display: 'none',
  },
  '&.Mui-expanded': {
    margin: 0,
  },
};

export const accordionStyles = {
  '&.MuiAccordion-root': {
    ...baseAccordionRootStyles,
    backgroundColor: 'background.primary',
  },
};

export const activeAccordionStyles = {
  '&.MuiAccordion-root': {
    ...baseAccordionRootStyles,
    backgroundColor: 'primary.soft',
    borderColor: 'primary.main',
  },
};

export const accordionDetailsStyles = {
  '&.MuiAccordionDetails-root': {
    padding: 0,
  },
};

export const nestedStepsStackStyles = {
  paddingLeft: '33px',
};
